export default __webpack_public_path__ + "static/media/BCA23.0070260f.jpg";